import { makeAutoObservable } from 'mobx';

const storageKey = 'uznali:dev:god-mode';

class DevelopmentMode {
  readonly available = import.meta.env.DEV || import.meta.env.MODE === 'development';
  enabled = false;

  constructor() {
    try {
      this.enabled = this.available && sessionStorage.getItem(storageKey) === 'true';
    } catch {
      // Development controls still work without browser storage.
    }
    makeAutoObservable(this, {}, { autoBind: true });
  }

  toggle = () => {
    if (!this.available) return;
    this.enabled = !this.enabled;
    try {
      sessionStorage.setItem(storageKey, String(this.enabled));
    } catch {
      // Keep the selection for the current visit.
    }
  };
}

export const developmentMode = new DevelopmentMode();
